import { inherits as _inherits, createClass as _createClass, extends as _extends, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper, typeof as _typeof, objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import BootstrapTable from 'react-bootstrap-table-next';
import { ActionBar } from './ActionBar.js';
import { SelectedItemsRibbon } from './SelectedItemsRibbon.js';
import { i18n } from '../../i18n/translate.js';
import { KebabCase } from '../../utils/StringUtil.js';
import { ProgressSpinner } from '../progress-spinner/component.js';
import { Actions } from '../Controls/Actions/component.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';
import { pickDataAttributes } from '../../utils/pickDataAttributes.js';
var _excluded = ["indeterminate"],
    _excluded2 = ["mode"];
/** renders data inside of a BootstrapTable component */

var Table = /*#__PURE__*/function (_React$Component) {
  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _callSuper(this, Table, [props]);

    _defineProperty(_this, "highlightRow", function (value) {
      _this.unhighlightRow();

      _this.setState({
        highlightRow: value
      });

      _this.timeout = setTimeout(_this.unhighlightRow, 3000);
    });

    _defineProperty(_this, "unhighlightRow", function () {
      if (_this.timeout) {
        clearTimeout(_this.timeout);
        _this.timeout = null;
      }

      _this.setState({
        highlightRow: null
      });
    });

    _defineProperty(_this, "trClassName", function (row, rowIndex) {
      var classNames = [];

      if (_this.state.highlightRow && row[_this.props.keyField] === _this.state.highlightRow) {
        classNames.push('highlighted');
      }

      switch (_typeof(_this.props.trClassName)) {
        case 'function':
          classNames.push(_this.props.trClassName(row, rowIndex));
          break;

        case 'string':
          classNames.push(_this.props.trClassName);
          break;
      }

      return classNames.join(' ');
    });

    _defineProperty(_this, "renderCaption", function () {
      if (!_this.props.tableCaption) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "sr-only"
      }, _this.props.tableCaption);
    });

    _defineProperty(_this, "getColumnWidth", function (field) {
      var widthUnits = ['%', 'px'];
      var width = field.columnOptions && field.columnOptions.width ? field.columnOptions.width : field.width;

      if (width && (typeof width === 'number' || !widthUnits.some(function (unit) {
        return width.includes(unit);
      }))) {
        width = "".concat(width, "px");
      }

      return {
        width: width,
        'min-width': width // for IE11

      };
    });

    _defineProperty(_this, "stopOverlayPropagation", function (e) {
      e.stopPropagation();
    });

    _defineProperty(_this, "resetSortText", function () {
      _this.props.fields.map(function (field) {
        var attrTxt = i18n.t('%s sortable', {
          postProcess: 'sprintf',
          sprintf: [field.title]
        });

        if (_this.props.options && field.name === _this.props.options.defaultSortName && _this.props.options.defaultSortOrder) {
          var dir = _this.props.options.defaultSortOrder === 'asc' ? i18n.t('ascending') : i18n.t('descending');
          i18n.t('%s default sortable %s', {
            postProcess: 'sprintf',
            sprintf: [field.title, dir]
          });
        }

        field.headerAttrs = field.sort ? {
          'aria-label': attrTxt,
          'data-object-type': _this.props.dataObjectType,
          'data-object-action': "sort-".concat(KebabCase(field.name))
        } : {};
      });
    });

    _defineProperty(_this, "findColumnByTitle", function (name) {
      return _this.props.fields.find(function (field) {
        return field.name === name;
      });
    });

    _defineProperty(_this, "alias", function (object, newProp, oldProp) {
      if (!object[newProp] && !!object[oldProp]) {
        object[newProp] = object[oldProp];
      }
    });

    _defineProperty(_this, "formatColumns", function () {
      var _this$props = _this.props,
          actions = _this$props.actions,
          actionsWidth = _this$props.actionsWidth,
          dropdownActions = _this$props.dropdownActions,
          keyField = _this$props.keyField;

      var fields = _this.props.fields.concat();

      if (actions && actions.length) {
        var defaultActionsWidth = actions.length === 4 ? 136 : 110;
        fields.push({
          name: 'actions',
          title: i18n.t('Actions'),
          canSort: false,
          actionColumn: true,
          width: actionsWidth || defaultActionsWidth,
          formatter: function formatter(_, row) {
            return /*#__PURE__*/React.createElement(Actions, {
              actions: actions,
              dropdownActions: dropdownActions,
              keyField: keyField,
              row: row
            });
          }
        });
      }

      return fields.map(function (field) {
        _this.alias(field, 'text', 'title');

        _this.alias(field, 'dataField', 'name');

        _this.alias(field, 'sort', 'canSort');

        field.headerFormatter = _this.renderColumnTitle;

        _this.resetSortText();

        if (field.sort) {
          field.onSort = function (name, ord) {
            var dir = ord === 'asc' ? i18n.t('ascending') : i18n.t('descending');

            var fld = _this.findColumnByTitle(name);

            _this.resetSortText();

            fld.headerAttrs = {
              'aria-label': i18n.t('%s sort %s', {
                postProcess: 'sprintf',
                sprintf: [fld.text, dir]
              }),
              'aria-sort': dir
            };

            if (_this.props.options && _this.props.options.onSortChange) {
              _this.props.options.onSortChange(name, ord);
            }
          };
        }

        field.headerStyle = field.style = _this.getColumnWidth(field);
        field.align = !field.align && field.columnOptions && field.columnOptions.dataAlign ? field.columnOptions.dataAlign : 'left';

        _this.alias(field, 'headerAlign', 'align');

        _this.alias(field, 'classes', 'className');

        if (field.actionColumn) {
          field.classes = field.classes ? 'action-column ' + field.classes : 'action-column';
        }

        return field;
      });
    });

    _defineProperty(_this, "handleUserClickEvent", function (e, row) {
      var selectionType = window.getSelection().type;

      if (selectionType !== 'Range' && _this.props.options.onRowClick) {
        _this.props.options.onRowClick(e, row);
      }
    });

    _defineProperty(_this, "customMultiSelectHeader", function (_ref) {
      var indeterminate = _ref.indeterminate,
          rest = _objectWithoutProperties(_ref, _excluded);

      return /*#__PURE__*/React.createElement("div", {
        className: "checkbox-personalized"
      }, /*#__PURE__*/React.createElement("input", _extends({
        type: "checkbox",
        ref: function ref(input) {
          if (input) input.indeterminate = indeterminate;
        }
      }, rest, {
        disabled: _this.props.isLoadingData || rest.disabled
      })), /*#__PURE__*/React.createElement("label", {
        htmlFor: 'checkbox' + (rest.rowIndex ? rest.rowIndex : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "check"
      })));
    });

    _defineProperty(_this, "customMultiSelect", function (_ref2) {
      var mode = _ref2.mode,
          rest = _objectWithoutProperties(_ref2, _excluded2);

      return /*#__PURE__*/React.createElement("div", {
        className: "checkbox-personalized"
      }, /*#__PURE__*/React.createElement("input", _extends({
        type: mode
      }, rest)), /*#__PURE__*/React.createElement("label", {
        htmlFor: 'checkbox' + rest.rowIndex
      }, /*#__PURE__*/React.createElement("div", {
        className: "check"
      })));
    });

    _defineProperty(_this, "selectRow", function () {
      if (!_this.props.selectRow) {
        return;
      }

      return _objectSpread2({
        selectionRenderer: _this.customMultiSelect,
        selectionHeaderRenderer: _this.customMultiSelectHeader
      }, _this.props.selectRow);
    });

    _this.state = {
      highlightRow: null
    };
    return _this;
  }

  _inherits(Table, _React$Component);

  return _createClass(Table, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unhighlightRow();
    }
  }, {
    key: "renderColumnTitle",
    value: function renderColumnTitle(column, colIndex, _ref3) {
      var sortElement = _ref3.sortElement;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "th-title"
      }, column.text), sortElement);
    }
  }, {
    key: "renderTable",
    value: function renderTable(enableHover) {
      var _this$props2 = this.props,
          actionBar = _this$props2.actionBar,
          classes = _this$props2.classes,
          data = _this$props2.data,
          keyField = _this$props2.keyField,
          options = _this$props2.options,
          selectedItems = _this$props2.selectedItems,
          tableContainerClass = _this$props2.tableContainerClass,
          tableContainerDataProps = _this$props2.tableContainerDataProps;
      var columns = this.formatColumns();
      var defaultSorted = [];
      var rowEvents = {};
      var containerClassName = tableContainerClass ? "react-bootstrap-table-container ".concat(tableContainerClass) : 'react-bootstrap-table-container';

      var noDataIndication = function noDataIndication() {};

      if (options) {
        if (!options.defaultSorted && !!options.sortName && !!options.sortOrder) {
          defaultSorted.push({
            dataField: options.sortName,
            order: options.sortOrder
          });
        } else {
          defaultSorted = options.defaultSorted;
        }

        if (!options.rowEvents && options.onRowClick) {
          rowEvents.onClick = this.handleUserClickEvent;
        } else {
          rowEvents = options.rowEvents;
        }

        if (!options.noDataIndication && options.noDataText) {
          noDataIndication = function noDataIndication() {
            return options.noDataText;
          };
        } else {
          noDataIndication = options.noDataIndication;
        }
      }

      var selectRow = this.selectRow();

      var className = _formatClassName([classes, {
        'custom-select-class': !!selectRow
      }]);

      var dataProps = pickDataAttributes(tableContainerDataProps);
      return /*#__PURE__*/React.createElement("div", _extends({
        className: containerClassName
      }, dataProps), /*#__PURE__*/React.createElement(SelectedItemsRibbon, selectedItems), actionBar && selectedItems && /*#__PURE__*/React.createElement(ActionBar, {
        buttons: actionBar,
        disabled: selectedItems.count === 0
      }), /*#__PURE__*/React.createElement(BootstrapTable, _extends({
        data: data,
        columns: columns,
        keyField: keyField,
        defaultSorted: defaultSorted,
        caption: this.renderCaption(),
        bordered: false,
        hover: enableHover
      }, this.props, {
        classes: className,
        selectRow: selectRow,
        rowClasses: this.trClassName,
        keyBoardNav: {
          clickToNav: false
        },
        rowEvents: rowEvents,
        noDataIndication: noDataIndication
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          isLoadingData = _this$props3.isLoadingData,
          options = _this$props3.options;
      var enableHover = options && options.onRowClick;
      var loading = isLoadingData === true;
      return /*#__PURE__*/React.createElement("div", {
        className: loading ? 'table-data-loading' : undefined
      }, loading && /*#__PURE__*/React.createElement(ProgressSpinner, {
        containerClassName: "everfi-list-loader"
      }), this.renderTable(enableHover));
    }
  }]);
}(React.Component);

_defineProperty(Table, "propTypes", {
  /* if present passed to actionBar component */
  actionBar: PropTypes.array,
  actions: PropTypes.arrayOf(PropTypes.shape({
    action: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    actionType: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    download: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    icon: PropTypes.string,
    target: PropTypes.string,
    title: PropTypes.string,
    tooltip: PropTypes.string,
    type: PropTypes.oneOf(['edit', 'delete'])
  })).isRequired,
  actionsWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  classes: PropTypes.string,

  /** array of data that will be rendered in he table */
  data: PropTypes.array.isRequired,
  dataObjectType: PropTypes.string,

  /** define how the table rows are rendered
   *  (passed to ResponsiveDataList -> Table -> BootstrapTable component)
   *  documentation of additional BootstrapTable props can be found at
   *  https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/column-props.html */
  dropdownActions: PropTypes.bool,
  fields: PropTypes.arrayOf(PropTypes.shape({
    /** set to true for an action column to add action styles */
    actionColumn: PropTypes.bool,

    /** set to true make the column sortable */
    canSort: PropTypes.bool,

    /** adds additional classes to the renered cells */
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

    /** don't really need this anymore for this version of BootstrapTable */
    columnOptions: PropTypes.object,

    /** overrides what is rendered as cell content */
    formatter: PropTypes.func,

    /** renders this row attribute as cell text */
    name: PropTypes.string,

    /** defines the column header */
    title: PropTypes.string,

    /** hard code the styled width of a column in either px or % */
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })).isRequired,

  /** specifies what row attribute is used as the key for each rendered row */
  keyField: PropTypes.string.isRequired,
  options: PropTypes.shape({
    /** sets a message to be displayed when the data array is empty */
    noDataText: PropTypes.string,

    /** callback(event, row) when a row is clicked
     *  note: when there is an onRowClick prop, row hover style is applied */
    onRowClick: PropTypes.func,

    /** callback(sortColumn, sortDirection) when sort is changed */
    onSortChange: PropTypes.func,

    /** column name to sort by */
    sortName: PropTypes.string,

    /** order to sort by */
    sortOrder: PropTypes.oneOf(['asc', 'desc']),

    /** DEPRECATED OPTINOS */
    defaultSortName: PropTypes.stirng,
    defaultSortOrder: PropTypes.oneOf(['asc', 'desc']),
    defaultSorted: PropTypes.arrayOf(PropTypes.shape({
      dataField: PropTypes.string,
      order: PropTypes.oneOf(['asc', 'desc'])
    })),
    noDataIndication: PropTypes.string,
    rowEvents: PropTypes.object
  }),
  selectRow: PropTypes.object,

  /** passed to SelectedItemsRibbon */
  selectedItems: PropTypes.shape({
    count: PropTypes.number
  }),

  /** set to true when you want to display a loading icon */
  isLoadingData: PropTypes.bool,

  /** Data props for the table container */
  tableContainerDataProps: PropTypes.object,

  /** add additional classes to the rendered rows */
  trClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /** adds a caption above the rendered table */
  tableCaption: PropTypes.string,

  /** adds a className to the div that wraps the BootstrapTable component */
  tableContainerClass: PropTypes.string
});

_defineProperty(Table, "defaultProps", {
  allowEdit: false,
  tableContainerDataProps: {}
});

Table.displayName = "Table";
export { Table };